import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=17729fd2&scoped=true&"
import script from "./Company.vue?vue&type=script&lang=ts&"
export * from "./Company.vue?vue&type=script&lang=ts&"
import style0 from "./Company.vue?vue&type=style&index=0&id=17729fd2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17729fd2",
  null
  
)

export default component.exports